import React from 'react'

const BookHub = () => {
  return (
    <div>BookHub</div>
  )
}

export default BookHub